export const navigationStrings = {
  home: 'Home',
  hobbies: 'Hobbies',
  insights: 'Insights',
  account: 'Account',
};
